import React, { Component } from 'react'
import ImmutablePropTypes from 'react-immutable-proptypes'
import { connect } from 'react-redux'
import styled from 'styled-components'
import { vars } from '../common'
import Scroll from '../../components/Scroll'
import { newUserMessage } from 'App/actions'

class QuickButtons extends Component {
  getComponentToRender = button => {
    const ComponentToRender = button.get('component')
    return (
      <ComponentToRender
        onQuickButtonClicked={this.props.handleButtonClick}
        button={button}
      />
    )
  }

  render() {
    if (this.props.buttons.size === 0) {
      return null
    }

    return (
      <Container>
        <Scroll style={{ width: '100%' }}>
          <List>
            {this.props.buttons.map((button, index) => (
              <Item key={index} role="button">
                {this.getComponentToRender(button)}
              </Item>
            ))}
          </List>
        </Scroll>
      </Container>
    )
  }
}

QuickButtons.propTypes = {
  buttons: ImmutablePropTypes.listOf(ImmutablePropTypes.map)
}

const mapStateToProps = state => ({
  buttons: state.widget.quickButtons
})

const mapDispatchToProps = dispatch => ({
  handleButtonClick: button => dispatch(newUserMessage(button))
})

export default connect(mapStateToProps, mapDispatchToProps)(QuickButtons)

const Container = styled.div`
  position: absolute;
  bottom: 0;
  width: calc(100% - ${vars.scrollBarWidth});
  background: var(--clr-white-to-grey-4, linear-gradient(
    to bottom,
    rgba(255, 255, 255, 0) 0%,
    rgba(255, 255, 255, 1) 10%,
    rgba(255, 255, 255, 1) 100%
  ));
`

const List = styled.ul`
  list-style: none;
  text-align: center;
  padding: 10px;
  margin: 0;
`

const Item = styled.li`
  display: inline-block;
  margin-right: 10px;
  padding-bottom: 10px;
`



// WEBPACK FOOTER //
// ./src/ChatWidget/components/QuickButtons/index.js